import { Button } from '@progress/kendo-react-buttons';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import type { CrisisResource } from './screenerTypes';

interface CrisisPanelProps {
  message: string;
  resources: CrisisResource[];
  onAcknowledge: () => void;
}

export function CrisisPanel({ message, resources, onAcknowledge }: CrisisPanelProps) {
  return (
    <>
      <div style={{ padding: '8px 0 16px' }}>
        <p style={{ margin: '0 0 16px', color: '#dc2626', fontWeight: 600, fontSize: 14 }}>
          {message}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {resources.map((r, i) => (
            <div
              key={i}
              style={{
                padding: '10px 14px',
                background: '#fef2f2',
                border: '1px solid #fecaca',
                borderRadius: 6,
              }}
            >
              <div style={{ fontWeight: 600, fontSize: 13, marginBottom: r.phone || r.url ? 4 : 0 }}>
                {r.label}
              </div>
              {r.phone && (
                <div style={{ fontSize: 12, color: '#475569' }}>
                  <a href={`tel:${r.phone.replace(/\D/g, '')}`} style={{ color: '#dc2626' }}>
                    {r.phone}
                  </a>
                </div>
              )}
              {r.url && (
                <div style={{ fontSize: 12, marginTop: r.phone ? 2 : 0 }}>
                  <a href={r.url} target="_blank" rel="noopener noreferrer" style={{ color: '#2563eb' }}>
                    {r.url}
                  </a>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <DialogActionsBar>
        <Button themeColor="primary" onClick={onAcknowledge}>
          I understand
        </Button>
      </DialogActionsBar>
    </>
  );
}
